import Url from 'url-parse';
import { replace } from 'lodash';

export function inferApiUrl() {
    const parsed = new Url(process.env.VUE_APP_API || window.location.href);
    parsed.set('host', replace(parsed.host, 'clients3.', 'api3.'));
    parsed.set('host', replace(parsed.host, 'clients.', 'api.'));
    parsed.set('host', replace(parsed.host, 'public-dot-', 'api-dot-'));
    parsed.set('host', replace(parsed.host, 'uniprix.', 'api3.'));
    parsed.set('host', replace(parsed.host, 'pharmaprix.', 'api3.'));
    parsed.set('host', replace(parsed.host, 'reacts.', 'api.'));
    return parsed.protocol + '//' + parsed.host;
}

export function inferPortalUrl(pathname = '') {
    const parsed = new Url(process.env.VUE_APP_PORTAL_URL || window.location.href);
    parsed.set('hostname', replace(parsed.hostname, 'clients3.', 'portal3.'));
    parsed.set('hostname', replace(parsed.hostname, 'clients.', 'portal.'));
    parsed.set('hostname', replace(parsed.hostname, 'public-dot-', 'portal-dot-'));
    parsed.set('hostname', replace(parsed.hostname, 'uniprix.', 'portal.'));
    parsed.set('hostname', replace(parsed.hostname, 'pharmaprix.', 'portal.'));
    // parsed.set('hostname', replace(parsed.hostname, 'reacts', 'portal.'));
    parsed.set('pathname', pathname);
    return parsed.toString();
}

export function inferCookieDomain() {
    let hostname = process.env.VUE_APP_COOKIE_DOMAIN || window.location.hostname;
    hostname = replace(hostname, 'clients3.', '');
    hostname = replace(hostname, 'clients.', '');
    hostname = replace(hostname, /public-dot-.*?\./, '');
    hostname = replace(hostname, /uniprix.*?\./, '');
    hostname = replace(hostname, /pharmaprix.*?\./, '');
    return hostname;
}

export function inferConsentDomain() {
    let hostname = process.env.VUE_APP_CONSENT_DOMAIN || window.location.hostname;
    hostname = replace(hostname, 'clients3.', 'portal3.');
    hostname = replace(hostname, 'clients.', 'portal.');
    hostname = replace(hostname, 'public-dot-', 'portal-dot-');
    hostname = replace(hostname, 'uniprix.', 'portal.');
    hostname = replace(hostname, 'pharmaprix.', 'portal.');
    return hostname;
}
